import './functions';
import './pages/list';

import {initList} from "./pages/list";

const routes = {
    'list': initList,
};

function runRouter() {
    const currentPage = document.body.dataset.page;
    if (routes[currentPage]) routes[currentPage]();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runRouter);
} else {
    runRouter();
}